<div class="transport-details-groups-dialog">

  <sc-flex vertical fitHeight stretchContent>

    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        <sc-padding>
          <sc-content-spacer vertical></sc-content-spacer>
          @for (group of transportExternalInformationsGroups; track group) {
            <sc-read-only-field [label]="" [value]="group.name"></sc-read-only-field>
            <sc-padding>
              @for (entry of group.transportExternalInformationsGroupEntries; track entry) {
                <sc-read-only-field [label]="entry.key" [value]="entry.value"></sc-read-only-field>
              }
            </sc-padding>
            <sc-content-spacer vertical></sc-content-spacer>
          }
        </sc-padding>
      </sc-scroll-pane>
    </sc-flex-fitting-content>

  </sc-flex>

</div>

